<app-page-header [pageTitle]="title()"></app-page-header>
<app-invoice-viewer [type]="type()" [mode]="mode()" />

<app-invoice-page-footer />
